const stickyHeaderDisplayFromMap = {
  withDrawer: {
    smallProfile: 170,
    normalProfile: 100,
  },
  withoutDrawer: {
    smallProfile: 145,
    normalProfile: 64,
  },
};

const HomeEventsSource = 'BA_home';
const ZOOM_MIN_LEVEL = 3;
const ZOOM_MAX_LEVEL = 20;
const MAP_RADIUS = 2000;
const INITIAL_MAP_ZOOM = 12;

export { stickyHeaderDisplayFromMap, HomeEventsSource, ZOOM_MIN_LEVEL, ZOOM_MAX_LEVEL, MAP_RADIUS, INITIAL_MAP_ZOOM };
